<template>
  <div class="modal-overlay overflow-y-auto" @click="$emit('close-modal')">
    <div class="modal" @click.stop>
      <div class="header">
        <img src="../assets/logo_mobile.png" alt="" />
      </div>

      <div class="w-full text-center mb-10 mt-16">
        <button class="styleLinkTransparent text-base p-2" @click="$emit('close-modal')">
          Cerrar ventana
        </button>
      </div>

      <div class="form">
        <div class="section_photo">
          <h1 class="subtitle">Imagen de perfil</h1>
          <img :src="actual_user_photo" alt="" />
        </div>
        <div class="container-buttons">
          <b-field class="file is-primary">
            <b-upload v-model="new_user_photo">
              <span class="button-img">
                <b-icon class="file-icon" icon="image" style="color: #ffffff"></b-icon>
                <span class="file-label" style="color: #ffffff">Seleccionar archivo</span>
              </span>
              <span class="file-name" v-if="new_user_photo">
                {{ new_user_photo.name }}
              </span>
            </b-upload>
            <button class="button-edit" :class="[disabled ? 'link-disabled' : '']" v-if="new_user_photo"
              @click="setUserPhoto">
              <b-icon class="file-icon" icon="upload" style="color: #ffffff"></b-icon>
              Subir imagen
            </button>
          </b-field>
          <button class="button-img" :class="[disabled ? 'link-disabled' : '']" style="margin-top: 15px"
            @click="deleteUserPhoto" v-if="hideButton === false">
            <b-icon class="file-icon" icon="delete" style="color: #ffffff"></b-icon>
            Borrar imagen
          </button>
        </div>
        <div class="container-msg-error">
          <p class="help is-danger" v-if="docType">Extensión no permitida</p>
        </div>
        <div>
          <p style="font-size: 13px;">Los archivos deben ser menores que 512 MB.</p>
          <p style="font-size: 13px;">Tipos de archivo permitidos: pdf, jpg, png.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['user_photo'],
  data: () => ({
    actual_user_photo: null,
    new_user_photo: null,
    new_user_photo_base64: null,
    hideButton: false,
    disabled: false,
    docType: false,
    file_ext: ''
  }),

  watch: {
    // When user upload a file, this will transform in base64
    new_user_photo: function (file) {
      console.log('Nuevo fichero')
      this.file_ext = file.name.split('.').pop()

      if (['jpg', 'jpeg', 'png', 'pdf'].includes(this.file_ext)) {
        console.log('Extensión permitida')
        this.docType = false
      if (file) {
        this.createBase64(file);
      } else {
        this.new_user_photo_base64 = null;
      }
     }  else {
        console.log('Extensión no permitida')
        this.docType = true
        return false
      }
    }
  },

  created() {
    this.getUserPhoto();
  },

  methods: {
    getUserPhoto() {
      this.$store
        .dispatch('auth/getPhoto')
        .then((response) => {
          console.log('Photo loaded')
          console.log(response);

          if (response.data.photo['fid'] === null || typeof response.data.photo[0] !== 'undefined') {
            if (response.data.photo[0].fid === null) {
              this.hideButton = true;
              this.disabled = false;
              this.actual_user_photo = response.data.photo[0].presets;
            }
          }
          else {
            this.hideButton = false;
            this.disabled = false;
            this.actual_user_photo = response.data.photo.presets;
          }
        })
    },
    setUserPhoto() {
      //console.log(this.new_user_photo_base64);
      if (['jpg', 'jpeg', 'png', 'pdf'].includes(this.file_ext) === false) {
        return false
      } else {
        this.$store
        .dispatch('auth/setProfilePhoto', {
          photo: [this.new_user_photo_base64]
        })
        .then((response) => {
          console.log('Set new photo')
          console.log(response);
          this.disabled = true;
          this.new_user_photo = null;
          this.getUserPhoto();
        })
      }
    },
    deleteUserPhoto() {
      this.$store
        .dispatch('auth/deletePhoto')
        .then((response) => {
          console.log('Photo deleted')
          console.log(response);
          this.disabled = true;
          this.getUserPhoto();
        })
    },

    createBase64(file) {
      var reader = new FileReader();

      var self = this;
      reader.onload = (event) => {
        self.new_user_photo_base64 = event.target.result;
        //console.log(self.new_user_photo_base64);
      }

      reader.readAsDataURL(file);
    },
  },
}
</script>

<style lang="scss" scoped>
.modal-overlay {
  z-index: 1000;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: white;
}

.modal {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  text-align: center;
  background-color: white;
  overflow-y: scroll;
}

.header {
  max-height: 60px;
  width: 100%;
  text-align: left;
  background-color: #17c8da;
  margin-bottom: 60px;

  img {
    width: 45px;
    height: 45px;
    margin-left: 30px;
    margin-top: 8px;
  }
}

.form {
  box-shadow: 0px 4px 25px rgba(0, 0, 0, 0.15);
  border-radius: 16px;
  background-color: #fff;
  min-height: 600px;
  margin-top: 40px;

  @media (min-width: 1024px) {
    min-width: 1000px;
  }
}

.link-disabled {
  pointer-events: none;
  cursor: default;
  background-color: lightgray !important;

  &:hover {
    background-color: lightgray !important;
  }
}

.colorLink {
  color: #17c8da;
}

.styleLinkBlue {
  background-color: #17c8da;
  border: 2px solid #17c8da;
  color: #ffffff;
  display: inline-block;
  padding: 16px 28px;
  text-decoration: none;
  min-width: 30px;
}

.styleLinkTransparent {
  background-color: transparent;
  border: 2px solid #17c8da;
  color: #17c8da;
  display: inline-block;
  text-decoration: none;
  min-width: 30px;
  cursor: pointer;
}

.styleLinkTransparent:hover {
  background-color: #17c8da;
  border: 2px solid #17c8da;
  color: #ffffff;
}

.container-buttons {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  padding: 1em 5em 0;


  @media (min-width: 1024px) {
    justify-content: center;
  }

  label.upload.control {
    margin-right: 10px;
    margin-top: 15px;

    .file-name {
      @media (max-width: 500px) {
        max-width: 8em;
      }
    }
  }

  .field.file.is-primary {
    flex-wrap: wrap;
    margin-bottom: 0;
  }
}

.container-msg-error {
 padding: 1em 5em 3em;
}

.button-img {
  background-color: #17c8da;
  border: 1px solid #17c8da;
  color: #ffffff;
  border-radius: 4px;
  display: inline-block;
  text-decoration: none;
  min-width: 100px;
  min-height: 40px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  font-family: 'Roboto', 'Avenir', Helvetica, Arial, sans-serif;
  font-size: 16px;
  padding: 0 20px;
}

.button-img:hover,
.button-edit:hover {
  background-color: #0b8c95;
  border: 1px solid #0b8c95;
}

.button-edit {
  background-color: #17c8da;
  border: 1px solid #17c8da;
  color: #ffffff;
  border-radius: 4px;
  display: inline-block;
  text-decoration: none;
  min-width: 100px;
  min-height: 40px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  font-family: 'Roboto', 'Avenir', Helvetica, Arial, sans-serif;
  font-size: 16px;
  padding: 0 20px;
  margin-right: 10px;
  margin-top: 15px;
}

.section_photo {
  padding: 4em 3em 3em 3em;
}
</style>
